<template>
  <Transition name="modal-popup">
    <div v-if="store.state.open.contactMe" class="modal-mask" @click.self="handleClose">
      <div ref="cardRef" class="modal-card glass">
        <button class="modal-close close" @click="handleClose">×</button>
        <div class="header">
          <h2 class="title">联系我</h2>
          <p class="desc">填写信息，我会尽快回复您</p>
        </div>
        <form @submit.prevent="handleSubmit" class="contact-form">
          <div class="form-row">
            <div class="form-item">
              <label>姓名</label>
              <input
                  v-model="form.nickname"
                  type="text"
                  placeholder="请输入您的姓名"
                  required
              />
            </div>
            <div class="form-item">
              <label>邮箱</label>
              <input
                  v-model="form.email"
                  type="email"
                  placeholder="用于接收回复"
                  required
              />
            </div>
          </div>

          <div class="form-item">
            <label>留言内容</label>
            <textarea
                v-model="form.message"
                rows="5"
                placeholder="请输入留言内容..."
                required
            ></textarea>
          </div>

          <div class="btn-wrap">
            <button class="submit-btn" :disabled="loading">
              {{ loading ? '发送中...' : '发送消息' }}
            </button>
          </div>
        </form>

        <div v-if="tip.show" class="tip" :class="{ success: tip.success, error: !tip.success }">
          {{ tip.text }}
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import {ref, reactive, watch} from 'vue'
import request from "@/api/request";
import store from "@/store";

//监听 open 变化，弹窗由关闭→打开时，赋值表单
watch(() => store.state.open.contactMe, (newVal) => {
  if (newVal) {
    // 弹窗打开，重置表单，使用父组件传过来的 username
    form.nickname = store.state.userInfo.nickname ?? ''
    form.username = store.state.userInfo.username ?? ''
    form.message = ''
    form.email = store.state.userInfo.email ?? ''
  }
})
const cardRef = ref(null)
const loading = ref(false)
const form = reactive({
  username: '',
  nickname: '',
  email: '',
  message: ''
})
const tip = reactive({
  show: false,
  success: false,
  text: ''
})

const handleClose = () => {
  store.commit('open/contactMe', false)
  tip.show = false
  loading.value = false
  form.username = ''
  form.nickname = ''
  form.email = ''
  form.message = ''
}

async function handleSubmit() {
  loading.value = true
  tip.show = false
  try {
    const response = await request.post("/v1/api/contactMe", {
      username: form.username,
      nickname: form.nickname,
      email: form.email,
      message: form.message
    })
    const resp = response.data;
    if (resp.responseCode === '0000') {
      tip.show = true
      tip.success = true
      tip.text = '发送成功！感谢留言'
      setTimeout(handleClose, 1400)
    } else {
      tip.show = true
      tip.success = false
      tip.text = resp.responseDesc
    }
  } catch (err) {
    tip.show = true
    tip.success = false
    tip.text = err.message
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: var(--laputa-card-background-deep-mask-gray);
  z-index: 9999;
  padding: 20px;
  box-sizing: border-box;
}

.modal-card {
  position: absolute;
  left: 50%;
  top: 50%;
  /* 最终停留位置 */
  transform: translate(-50%, -50%) scale(1);
  width: 100%;
  max-width: 720px;
  max-height: calc(100vh - 40px);
  overflow-y: auto;
  border-radius: 20px;
  padding: 36px 32px;
  box-sizing: border-box;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
  transition: all 0.36s cubic-bezier(0.25, 0.8, 0.25, 1);
}

/* ========== 关键修改：-120vh，整个卡片跑到屏幕视口外面最顶部 ========== */
.modal-popup-enter-from .modal-card {
  transform: translate(-50%, -120vh) scale(0.3);
  opacity: 0;
}

.modal-popup-enter-active .modal-card {
  transition: all 0.36s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.modal-popup-enter-to .modal-card {
  transform: translate(-50%, -50%) scale(1);
  opacity: 1;
}

.modal-popup-leave-from .modal-card {
  opacity: 1;
}

.modal-popup-leave-to .modal-card {
  transform: translate(-50%, -120vh) scale(0.3);
  opacity: 0;
}

.modal-popup-leave-active .modal-card {
  transition: all 0.24s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.modal-close {
  position: absolute;
  top: 16px;
  right: 18px;
  font-size: var(--laputa-fontsize-28);
}

.header {
  margin-bottom: 28px;
  text-align: center;
}

.title {
  font-size: var(--laputa-fontsize-28);
  font-weight: 700;
  margin: 0 0 8px;
  color: var(--laputa-common-font-color);
}

.desc {
  font-size: var(--laputa-fontsize-15);
  color: var(--laputa-common-secondary-font-color);
  margin: 0;
}

.contact-form {
  width: 100%;
}

.form-row {
  display: flex;
  gap: 24px;
}

.form-item {
  flex: 1;
  margin-bottom: 20px;
}

.form-item label {
  display: block;
  font-size: var(--laputa-fontsize-14);
  color: var(--laputa-common-thirdary-font-color);
  margin-bottom: 8px;
}

.form-item input,
.form-item textarea {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid var(--laputa-glass-header-separator);
  border-radius: 20px;
  padding: 14px 18px;
  font-size: var(--laputa-fontsize-14);
  background: var(--laputa-glass-background);
  color: var(--laputa-common-thirdary-font-color);
  transition: 0.22s ease;
}

.form-item input{
  border-radius: 999px;
}
.form-item input:focus,
.form-item textarea:focus {
  outline: none;
  background: var(--laputa-body-background);
  border-color: var(--laputa-primary);
}

.form-item textarea {
  resize: vertical;
}

.btn-wrap {
  text-align: center;
  margin-top: 8px;
}

.submit-btn {
  width: 220px;
  padding: 14px;
  border-radius: 999px;
  border: none;
  background: var(--laputa-btn-background);
  color: var(--laputa-common-inverse-font-color);
  font-size: var(--laputa-fontsize-15);
  font-weight: 500;
  cursor: pointer;
  transition: 0.22s;
}

.submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.tip {
  margin-top: 16px;
  padding: 14px 16px;
  border-radius: 10px;
  font-size: var(--laputa-fontsize-14);
  text-align: center;
}

.tip.success {
  background: #ecfdf5;
  color: #047857;
}

.tip.error {
  background: #fef2f2;
  color: #b91c1c;
}

@media (max-width: 992px) {
  .modal-card {
    padding: 28px 24px;
  }

  .title {
    font-size: 28px;
  }

  .form-row {
    gap: 16px;
  }
}

@media (max-width: 768px) {
  .modal-mask {
    padding: 12px;
  }

  .modal-card {
    padding: 24px 20px;
    border-radius: 14px;
    max-height: calc(100vh - 24px);
  }

  .title {
    font-size: 24px;
  }

  .header {
    margin-bottom: 20px;
  }

  .form-row {
    flex-direction: column;
    gap: 0;
  }

  .submit-btn {
    width: 100%;
  }
}
</style>